import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Grid, Typography } from "@mui/material"

import { multimediaCarouselInitPos } from "@signals"


export default function MultimediaRow({ title, multimedia=[], handleClick, Container=null }) {
	const normMultimedia = multimedia ?? []
	const haveMultimedia = normMultimedia.length > 0

	return <>
		<Grid item xs={12}>
			<Typography variant="subtitle2">
				{title} { !haveMultimedia && "--" }
			</Typography>
		</Grid>

		{ !!haveMultimedia && <Grid item xs={12} sx={{ display: "flex", gap: .5, cursor: "pointer" }}>
			{ normMultimedia.map((item, idx) => <Box
				key={idx}
				onClick={() => batch(() => {
					multimediaCarouselInitPos.value = idx
					handleClick(normMultimedia)
				})}
			>
				<Container item={item} />
			</Box>) }
		</Grid> }
	</>
}